import { DOC_CLASS_CHECK, IShiftDocumentItem } from "../commands";
import {
  RECEIPT_TYPE_BY_SUB_TYPE_NAME,
  TRANSACTION_DOC_TYPES,
} from "./receipts.constants";
import { IReceiptSummary } from "./receipts.models";

/** Technical documents share the `Check` class; only transactions are receipts. */
export const isTransactionDocument = (document: IShiftDocumentItem): boolean =>
  document.DocClass === DOC_CLASS_CHECK &&
  TRANSACTION_DOC_TYPES.includes(document.CheckDocType);

export const toReceiptSummary = (
  document: IShiftDocumentItem,
): IReceiptSummary => ({
  fiscalNumber: document.NumFiscal,
  localNumber: Number(document.NumLocal),
  issuedAt: document.DocDateTime,
  type: RECEIPT_TYPE_BY_SUB_TYPE_NAME[document.CheckDocSubType] ?? "sale",
  isRevoked: Boolean(document.Revoked),
  isStorned: Boolean(document.Storned),
});
